'use client';

import type { FunctionComponent } from 'react';

interface SendStopButtonProps {
  streaming: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const SendStopButton: FunctionComponent<SendStopButtonProps> = ({
  streaming,
  disabled,
  onClick,
}) => (
  <button
    className="ml-auto w-6 h-6 rounded-[5px] bg-acc text-white inline-flex items-center justify-center disabled:opacity-30 disabled:cursor-not-allowed transition-all font-sans font-semibold text-[13px]"
    onClick={onClick}
    disabled={disabled}
    aria-label={streaming ? 'Stop' : 'Send'}
  >
    {streaming ? (
      <svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true">
        <rect x="0" y="0" width="10" height="10" rx="1.5" fill="currentColor" />
      </svg>
    ) : (
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    )}
  </button>
);
